import css from "./AppIcon.module.scss"
import Img from "./Img"

const AppIcon = ({ src, size }) => {
  return (
    <Img
      src={src}
      fallbackImg="/img/app_icon_fallback.svg"
      alt={"icon"}
      width={size}
      height={size}
      className={css.appIcon}
      style={{ borderRadius: `${size * 0.2}px` }}
    />
  )
}

export default AppIcon
